// extracted by css-extract-rspack-plugin
export default {"enter":"push__enter___Gr9ko","enterActive":"push__enterActive___IZE43","exit":"push__exit___JpgcA","exitActive":"push__exitActive___zZ96M"};